import { Inject, Component, OnInit } from '@angular/core';
import insertTextAtCursor from 'insert-text-at-cursor';
import { Variavel } from 'src/app/models/variavel';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { FornecedorEstruturaItemService } from 'src/app/services/fornecedor-estrutura-item.service';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';
import { InfoRegrasEstruturaModalComponent } from '../info-regras-estrutura-modal/info-regras-estrutura-modal.component';
import { VariavelFormula } from 'src/app/models/variavel-formula';
import { VariavelFormulaService } from 'src/app/services/variavel-formula.service';

declare const $: any;

@Component({
  selector: 'app-formula-variavel-modal',
  templateUrl: './formula-variavel-modal.component.html',
  styleUrls: ['./formula-variavel-modal.component.scss']
})
export class FormulaVariavelModalComponent implements OnInit {
  variavelPersonalizada: VariavelFormula;

  autorModal = 0; // 0 - assunto | 1 - texto
  variavelSelecionada: Variavel;
  variaveis: Variavel[] = [];

  grupos: string[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private dialogRef: MatDialogRef<FormulaVariavelModalComponent>,
    private variavelFormulaService: VariavelFormulaService,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private dialog: MatDialog
  ) {
    if(this.data.variavelPersonalizada) {
      this.variavelPersonalizada = this.data.variavelPersonalizada;
    } else {
      this.variavelPersonalizada = new VariavelFormula();
    }
  }

  ngOnInit(): void {
    this.buscarVariaveis();

    this.dialogRef.disableClose = true;
  }

  filtrarVariaveis(grupo) {
    return this.variaveis.filter(p => p.grupo === grupo);
  }

  selecionarVariavel(variavel: Variavel) {
    this.variavelSelecionada = variavel;
    $('#modalVariaveis').modal('hide');
  }

  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');

    this.fornecedorEstruturaService.consultarVariaveis(false).subscribe(
      (vars) => {
        this.variaveis = vars;
        this.grupos = [...new Set(this.variaveis.map(p => p.grupo))];

        this.carregandoService.esconde('buscarVariaveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(erro);
      }
    );
  }

  mostrarVariaveis() {
    this.autorModal = 0;
    this.variavelSelecionada = undefined;
    $('#modalVariaveis').modal({});

    $('#modalVariaveis').on('hidden.bs.modal', (e) => {

      if (this.variavelSelecionada && this.autorModal == 0) {
        const el = document.getElementById('formula');
        insertTextAtCursor(el, this.variavelSelecionada.texto);
      }
      $('#modalVariaveis').off('hidden.bs.modal');
    });
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    this.variavelFormulaService.salvar(this.variavelPersonalizada).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Variável salva com sucesso!!!')
        this.dialogRef.close(true);
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    )
  }

  abrirModalInfo() {
    const largura = Number($('body').width());
    this.dialog.open(InfoRegrasEstruturaModalComponent, {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card',
    });
  }

  fechar() {
    this.dialogRef.close();
  }

}
